<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='cn'" command="cn">
        中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">
        English
      </el-dropdown-item>

    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {

      if (this.$i18n.locale === "cn") {
        this.$message({
          message: "Switch English Success",
          type: "success",
        });
      } else {
        this.$message({
          message: "切换中文成功",
          type: "success",
        });
      }
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      // this.$message({
      //   message: 'Switch Language Success', 
      //   type: 'success'
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue